import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useInspectionsEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.Inspections, false);

  return Boolean(isEnabled);
}
